import { allowedDateFormats, dateTime } from './dateTime';

export const normalize = (value) => value?.trim();
export const toNum = (value) => (value ? Number(value) : value);
export const toUTC = (value) =>
  dateTime(value, allowedDateFormats, true).utc().format();
